export default "__VITE_ASSET__DemBIcJy__"